import { useEffect, useState } from "react";
import api from "../../../api"; // Adjust if needed
import { getBadgesForProfile } from "../../../components/profile/Badges";
import BadgeDisplay from '../../../components/layout/BadgeDisplay';
import StreakDisplay from "../../../components/layout/StreakDisplay"

export default function Achievements() {
    const [profile, setProfile] = useState(null);
    const latestBadges = getBadgesForProfile(profile).slice(-4); // last 3 badges

    // fetch profile data
    useEffect(() => {
        api.get("profile/")
        .then((res) => {
            setProfile(res.data);
        })
        .catch((err) => {
            console.error("Error loading profile:", err);
        });
    }, []);

    if (!profile) return null;

    const ligningsmesterBadges = getBadgesForProfile(profile).filter((badge) => badge.label === "ligningsmester");
    const formelknuserBadges = getBadgesForProfile(profile).filter((badge) => badge.label === "formelknuser");
    const trigonometerBadges = getBadgesForProfile(profile).filter((badge) => badge.label === "trigonometer");

    return (
        <div className="card">
            {/* Badges */}
            <h1>Achievements</h1>

                {/* Badges */}
                <BadgeDisplay
                    latestBadges={latestBadges}
                />

                {/* Streakinfo */}
                <StreakDisplay
                    streak={profile?.streak || 0}
                    isTodayActive={profile?.streak_today}
                />


        </div>
    );
}